import React, { useEffect } from 'react'
import Button from '../../templates/Button'
import { AddUser, Group } from 'iconoir-react'
import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { getAllAdmins } from '../../../redux_store/auth/auth_thunk'
import { LOADING } from '../../../redux_store/actionTypes'
import LoadingModal from '../../templates/modals/LoadingModal'

const AdminsPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { admins, status } = useSelector((state) => state.auth);

  useEffect(() => {
    dispatch(getAllAdmins());
    // eslint-disable-next-line
  }, []);

  return (
    <div className='space-y-6'>
      {status === LOADING && <LoadingModal message={'Loading data...'} />}

      {/* Page Header */}
      <div className='flex items-center justify-between'>
        <div>
          <h1 className='text-2xl font-bold text-surface-800'>System Administrators</h1>
          <p className='text-surface-500 mt-1'>Manage admin accounts and permissions</p>
        </div>
        <Button
          onClick={() => navigate('/admins/create')}
          label={'Add Admin'}
          variant="primary"
          icon={<AddUser strokeWidth={2} className='w-4 h-4' />}
        />
      </div>

      {/* Admins Table */}
      <div className='card p-0 overflow-hidden'>
        <table className="table-modern">
          <thead>
            <tr>
              <th>Admin</th>
              <th>Email Address</th>
              <th>Phone Number</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {admins && admins.length > 0 ?
              admins.map((admin, index) =>
                <tr key={admin.id || index}>
                  <td>
                    <div className="flex items-center gap-3">
                      <img
                        className="w-10 h-10 rounded-xl object-cover ring-2 ring-surface-100"
                        src={admin.profile_pic}
                        alt=""
                        loading="lazy"
                      />
                      <div>
                        <p className="font-semibold text-surface-800">
                          {admin.lastname} {admin.firstname}
                        </p>
                        <p className="text-xs text-surface-400 capitalize">
                          Administrator
                        </p>
                      </div>
                    </div>
                  </td>
                  <td>{admin.email}</td>
                  <td className='font-medium'>{admin.phone_number}</td>
                  <td>
                    {admin.is_online ? (
                      <span className='badge-success'>
                        <span className='w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse' />
                        Online
                      </span>
                    ) : (
                      <span className='badge bg-surface-100 text-surface-500'>
                        <span className='w-1.5 h-1.5 rounded-full bg-surface-400' />
                        Offline
                      </span>
                    )}
                  </td>
                </tr>
              ) :
              <tr>
                <td colSpan={4} className="text-center py-12">
                  <div className='flex flex-col items-center gap-3'>
                    <div className='w-16 h-16 rounded-2xl bg-surface-100 flex items-center justify-center'>
                      <Group strokeWidth={1.5} className='w-8 h-8 text-surface-400' />
                    </div>
                    <div>
                      <p className='font-medium text-surface-600'>No admins found</p>
                      <p className='text-sm text-surface-400'>Add your first administrator</p>
                    </div>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default AdminsPage
